import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {ActionLink, InteractiveTable} from 'components';
import LiabilityCalculationModal from './LiabilityCalculationModal';
import {t} from 'shared/core';
import {types, endpoints} from 'main/tools';
import {TimeOffLiabilityBalance} from 'stores/time_off';
import {useModal} from 'shared/hooks';

const CalculationDetailsLink = observer(({model, uiState}) => {
  return (
    <ActionLink onClick={() => uiState.openLiabilityCalculationModal(model)}>
      <FormattedMessage id='employees.profile.time_off.liability.Show Calculation'/>
    </ActionLink>
  );
});

const COLUMNS = [
  {
    header: 'employees.profile.time_off.liability.Time Off Type',
    render: model => model.type.name,
    width: 5
  },
  {
    header: 'employees.profile.time_off.liability.Liability Balance',
    attribute: 'totalLiabilityView',
    width: 4
  },
  {
    component: CalculationDetailsLink,
    width: 3
  }
];

const LiabilityTable = observer(({uiState}) => {
  const {parentState, employeeId} = uiState;
  const liabilityCalculationModalOpen = useModal(uiState, 'LiabilityCalculationModal', 'selectedLiabilityBalance', TimeOffLiabilityBalance);

  if (!parentState.employee.pendingOrCurrentlyTerminated) return null;

  return (
    <React.Fragment>
      <InteractiveTable
        uiState={uiState}
        title={t('employees.profile.time_off.liability.Time Off Liability')}
        columns={COLUMNS}
        searchable={false}
        showLinks={false}
        proxy={{
          type: 'async',
          modelType: types.TIME_OFF.LIABILITY_BALANCE,
          model: TimeOffLiabilityBalance,
          endpoint: endpoints.TIME_OFF.LIABILITY_BALANCES.with(employeeId)
        }}
      />
      <LiabilityCalculationModal isOpen={liabilityCalculationModalOpen} uiState={uiState}/>
    </React.Fragment>
  );
});

export default LiabilityTable;
